import { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';
import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { classNames } from '@isocel/front-common';

const svg = () => (
    <svg viewBox="0 0 100 100" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h100v100H0Z M8 8v72h6v-20h20v20h6v-42h20v42h6v-66h20v66h6V8Z M8 88v4h84v-4Z" />
    </svg>
);

type Props = IconComponentProps & RefAttributes<HTMLSpanElement>;

const CounterSVG: ForwardRefExoticComponent<Props> = forwardRef((props, ref) => (
    <Icon component={svg} {...props} ref={ref} className={classNames('svg-counter', props.className)} />
));

export default CounterSVG;
